import React, { useEffect, useState } from 'react';
import axios from "axios";
import ReactDOMServer from 'react-dom/server';
import { AppMultiSelect, AppRemixIcon } from '@/layout/AppComponents';
import BtnOptions from './BtnOptions';
import Translator from '../../../../components/helpers/Translator';
import { axiosPath } from '../../../../../routing/helpers/router';
import useIsMounted from '../../../../components/hooks/useIsMounted';

const Report17Options = (props) => {
  const { handleOnSetFieldValue, handleOnSubmit, handleOnSave, values } = props;
  const isMounted = useIsMounted();
  const [availableStandards, setAvailableStandards] = useState();
  const [reportOptions, setReportOptions] = useState();

  // > LOAD REPORT OPTIONS //
  useEffect(() => {
    axios
      .post(axiosPath("api_r_user_module_intelligence_getReportOptions"), {
        report: 17,
      })
      .then((r) => {
        if (isMounted.current) {
          setReportOptions(r.data);
        }
      })
      .catch(() => "");
  }, []);
  // < LOAD REPORT OPTIONS //

  const handleCalculateStandards = () => {
    axios
      .post(axiosPath("api_r_user_module_intelligence_getReportOptions"), {
        report: 17,
        calculateStandards: values.customPlants,
      })
      .then((r) => {
        if (isMounted.current) {
          setAvailableStandards(r.data.standards);
        }
      })
      .catch(() => "");
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <AppMultiSelect
            icon={<AppRemixIcon icon="folder-2" />}
            options={reportOptions?.customPlants || []}
            title={
              <Translator file="module-intelligence" name="module.int.group" />
            }
            placeholder={ReactDOMServer.renderToString(
              <Translator file="module-intelligence" name="select.an.option" />
            )}
            value={values.customPlants || []}
            onChange={(e) => {
              handleOnSetFieldValue('customPlants', e);
              if (availableStandards) setAvailableStandards(null);
              if (values?.standards) handleOnSetFieldValue('standards', []);
            }}
            isLoading={!reportOptions}
            hasSearchBox
            hasSelectOptions
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-12">
          {!values.customPlants || values.customPlants.length === 0 ? (
            <span className="btn btn-outline-info btn-block disabled">
              <Translator
                file="module-intelligence"
                name="calculate.standards.base.on.groups"
              />
            </span>
          ) : (
            <span
              className="btn btn-outline-info btn-block"
              onClick={() => {
                setAvailableStandards(null);
                handleCalculateStandards();
              }}
            >
              <Translator
                file="module-intelligence"
                name="calculate.available.standards"
              />
            </span>
          )}
        </div>
      </div>
      {availableStandards && (
        <>
          <div className="row">
            <div className="col-lg-12">
              <AppMultiSelect
                icon={<AppRemixIcon icon="folder-2" />}
                options={availableStandards || []}
                title={
                  <Translator file="module-intelligence" name="standard" />
                }
                placeholder={ReactDOMServer.renderToString(
                  <Translator
                    file="module-intelligence"
                    name="select.an.option"
                  />
                )}
                value={values.subcategories || []}
                onChange={(e) => handleOnSetFieldValue('subcategories', e)}
                hasSearchBox
                hasSelectOptions
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-12">
                  <BtnOptions
                    isDisabled={
                      !values.customPlants ||
                      values.customPlants.length === 0 ||
                      !values.subcategories ||
                      values.subcategories.length === 0
                    }
                    handleOnSave={() => handleOnSave(true)}
                    handleOnSubmit={() => handleOnSubmit()}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Report17Options;
